import Navbar from "../components/Navbar";
import Chapter5thongtin from "./Chapter5thongtin";
function Chapter5(){
    return(
        <>
        <Navbar/>
        <Chapter5thongtin/>
        </>
    )
}
export default Chapter5;